import React from 'react';
import Form, { Actions, Checkboxes, Radio, TextField } from '../../../Components/Form';

const TransactionSearch = ({searchData, setSearchData}) => {
    return <Form data={searchData} onSubmit={setSearchData} closeModalOnSubmit>
        <TextField name="search" label="Search" />
        <Radio name="direction"
            label="Type"
            options={[
                {value: 'Credit', label: 'Credit'},
                {value: 'Debit', label: 'Debit'},
            ]}
        />
        <Checkboxes name="statuses"
            label="Status"
            options={[
                {value: 'New', label: 'New'},
                {value: 'Ignored', label: 'Ignored'},
                {value: 'Matched', label: 'Matched'},
                {value: 'Converted', label: 'Confirmed'},
            ]}
        />
        <Actions submit={{label: 'Search'}} />
    </Form>;
}

export default TransactionSearch;
